import { store } from "../Store/store";
import { showSelectedCategory, setCategory } from "../Actions/firebaseActions";
import { databaseRef } from "../Utilities/firebase";
import orderList from "../Utilities/orderList";

export default function categorizeList(category, screen) {
  var list = [];
  let username = store.getState().firebase.username;
  var listOrder = store.getState().firebase.listOrder;

  if (listOrder === undefined) {
    listOrder = "date newest";
  }

  var firebaseCall = databaseRef.ref("users/" + username + "/" + screen);

  firebaseCall.once("value", (snapshot) => {
    snapshot.forEach((element) => {
      list.push(element.val());
    });
  });

  var allowedCategories = [];

  if (category === "meat") {
    allowedCategories = [
      "Kött & Fågel",
      "Chark, korv & pålägg",
      "Fisk & Skaldjur",
      "meat",
    ];
  } else if (category === "fruit") {
    allowedCategories = [
      "Vegetariska alt.",
      "Grönsaker, svamp, lök & rotfrukter",
      "Frukt och bär",
      "fruit",
    ];
  } else if (category === "dairy") {
    allowedCategories = ["Mejeri", "dairy"];
  } else if (category === "pantry") {
    allowedCategories = [
      "Skafferi",
      "Bröd & Lyxbröd",
      "Konserver och burkar",
      "Kryddor, oljor & smaksättare",
      "Bakning och desserter",
      "Godis, snacks & glass",
      "pantry",
    ];
  } else if (category === "premade") {
    allowedCategories = [
      "Färdigrätter och snabblagat",
      "Färdiga tillbehör",
      "premade",
    ];
  } else if (category === "drinks") {
    allowedCategories = ["Dryck", "drinks"];
  } else if (category === "babies") {
    allowedCategories = ["Barn", "Djur", "babies"];
  }

  if (category === "all") {
    if (list.length > 0) {
      orderList(list, listOrder, screen);
    }
    store.dispatch(setCategory(category));
  } else {
    var objArray = [];
    if (category === "uncategorized") {
      list.forEach((element) => {
        if (
          element.cat_name === null ||
          element.cat_name === "" ||
          element.cat_name === undefined
        ) {
          objArray.push(element);
        }
      });
    } else {
      list.forEach((element) => {
        if (allowedCategories.includes(element.cat_name)) {
          objArray.push(element);
        }
      });
    }
    store.dispatch(showSelectedCategory(objArray, screen, category));
  }
}
